import { createApp } from 'vue';
import '@lottiefiles/lottie-player';
import App from '../app.vue';
import router from './router';
import { installMeta } from './meta-manager';
import { observeVisibility } from './observe-visibility';

window.scrollProgress = 0;
window.scrollHeight = Infinity;

const app = createApp(App);
app.use(router);
app.directive('observe-visibility', observeVisibility);
installMeta(app);
router.isReady().then(() => app.mount('#app'));
